"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import React from "react";
import { ContentTabProvider } from "../brain/ContentTabContext";
import WavesMessagesWrapper from "../shared/WavesMessagesWrapper";
interface Props {
  readonly children: ReactNode;
  readonly showLeftSidebar?: boolean | undefined;
  readonly allowRightSidebar?: boolean | undefined;
  readonly allowDropOverlay?: boolean | undefined;
}
const WavesDesktop: React.FC<Props> = t0 => {
  const $ = _c(5);
  const {
    children,
    showLeftSidebar: t1,
    allowRightSidebar: t2,
    allowDropOverlay: t3
  } = t0;
  const showLeftSidebar = t1 === undefined ? true : t1;
  const allowRightSidebar = t2 === undefined ? true : t2;
  const allowDropOverlay = t3 === undefined ? true : t3;
  let t4;
  if ($[0] !== allowDropOverlay || $[1] !== allowRightSidebar || $[2] !== children || $[3] !== showLeftSidebar) {
    t4 = <WavesMessagesWrapper defaultPath="/waves" showLeftSidebar={showLeftSidebar} allowRightSidebar={allowRightSidebar} allowDropOverlay={allowDropOverlay}>{children}</WavesMessagesWrapper>;
    $[0] = allowDropOverlay;
    $[1] = allowRightSidebar;
    $[2] = children;
    $[3] = showLeftSidebar;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
const WavesDesktopWithProvider: React.FC<Props> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ContentTabProvider><WavesDesktop {...props} /></ContentTabProvider>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default WavesDesktopWithProvider;